import { render, staticRenderFns } from "./LeaveRecordEdit.vue?vue&type=template&id=be0da9ca"
import script from "./LeaveRecordEdit.vue?vue&type=script&lang=js"
export * from "./LeaveRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports